<template>
    <div class="flex-grow-1 container-p-y">
        <courses-list-component></courses-list-component>
    </div>

</template>
<script>
import CoursesListComponent from './layouts/CoursesListComponent'
import { useUserStore } from '../../../stores/UserStore.js'
export default {
    setup(){
        return{
            userStore:useUserStore(),
        }
    },
    components:{
        CoursesListComponent
    }
}
</script>
